import { useEffect, useState } from "react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { apiGet, apiPatch } from "@/services/api";

export function VendorSettingsPage() {
  const [form, setForm] = useState({
    businessName: "",
    ownerName: "",
    email: "",
    phone: "",
    address: "",
    description: "",
    logo: "",
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    void apiGet<{ vendor: Record<string, string | null> }>("/api/vendors/me").then((d) => {
      if (!d?.vendor) return;
      setForm({
        businessName: d.vendor.businessName ?? "",
        ownerName: d.vendor.ownerName ?? "",
        email: d.vendor.email ?? "",
        phone: d.vendor.phone ?? "",
        address: d.vendor.address ?? "",
        description: d.vendor.description ?? "",
        logo: d.vendor.logo ?? "",
      });
    });
  }, []);

  async function save() {
    setSaving(true);
    try {
      await apiPatch("/api/vendors/me", form);
      toast.success("Settings saved");
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Could not save");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="amazon-card max-w-2xl space-y-4 p-6">
      <h2 className="text-xl font-bold">Store settings</h2>
      {(
        [
          ["businessName", "Business name"],
          ["ownerName", "Owner name"],
          ["email", "Email"],
          ["phone", "Phone"],
          ["address", "Address"],
          ["description", "Description"],
          ["logo", "Logo URL"],
        ] as const
      ).map(([key, label]) => (
        <label key={key} className="block text-sm">
          <span className="font-bold">{label}</span>
          <input
            value={form[key]}
            onChange={(e) => setForm((f) => ({ ...f, [key]: e.target.value }))}
            className="mt-1 w-full rounded border border-slate-300 px-3 py-2 dark:border-white/10 dark:bg-white/5"
          />
        </label>
      ))}
      <Button disabled={saving} onClick={() => void save()}>
        {saving ? "Saving…" : "Save"}
      </Button>
    </div>
  );
}
